import QrScanner from 'qr-scanner';
import { useEffect, useRef } from 'react';

type ScannerProps = {
  onDecode: (result: QrScanner.ScanResult) => void;
};

const Scanner = ({ onDecode }: ScannerProps) => {
  const videoEl = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoEl.current) {
      // @ts-ignore
      const qrScanner = new QrScanner(videoEl.current, onDecode, {
        preferredCamera: 'environment',
        maxScansPerSecond: 5,
        highlightScanRegion: true,
        returnDetailedScanResult: false,
      });
      qrScanner.setInversionMode('both');
      qrScanner.start();

      return () => {
        qrScanner.stop();
        qrScanner.destroy();
      };
    }
  }, [videoEl, onDecode]);

  return (
    <div className="relative w-full overflow-hidden rounded-xl bg-gray-950">
      <video ref={videoEl} className="w-full" />
    </div>
  );
};

export default Scanner;
